module.exports = __webpack_public_path__ + "img/logo-sepatu-kw.d124113b.png";